import React from "react";
import './Cartitems.css';
//import {Helmet} from "react-helmet";
import AuthService from '../Services/auth.service';
import CartService from '../Services/cart.service';
//import {  InputGroup, Input, Button, InputGroupAddon } from "reactstrap";
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import RemoveOutlinedIcon from '@mui/icons-material/RemoveOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import ReactLoading from 'react-loading';
import  './Products.css';
import  './Variants.css';


class Variants extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            showQty: undefined,
            disabled:'',
            selectedItem: this.props.itm?this.props.itm['item_code']:undefined,
            selectedQty: 1,
            selectedRate: this.props.itm?this.props.itm['price']:undefined,
            menu:[],
            stockStatus:false,
            btnTxt:'Add to cart',
        }
    }


    async componentDidMount(){
        this.getData(this.state.btnTxt)
        this.checkItem(this.props.itm['item_code'])
    }
    async getData(){
        console.log(this.props.itm.item_code)
        if(this.props.itm['stock'] > 0){
            this.setState({stockStatus:true})
        }else{
            this.setState({btnTxt:'Out of Stock'})
        }


        let cart = AuthService.getCartitems()
  
        try{
            if(cart.length > 0){
                
                for (let itm in cart) {
       //console.log(cart[itm]['item_code']===this.props.itm['name'])
                        if(cart[itm]['item_code']===this.props.itm['item_code']){
                                this.setState({showQty:"yes"})
                                this.setState({selectedItem:cart[itm]['item_code']})
                                this.setState({selectedQty:cart[itm]['qty']})
                            // this.setState({disabled:"disabled"})
                           // alert(this.state.selectedQty)
                        }
                    
                } 
            }
        }
        catch(e){ }
    }
    componentDidUpdate(){
        
    }
    
    addQty = async e => {
        //alert("ok")
        e.preventDefault();
        let qty = this.state.selectedQty
        this.setState({ selectedQty: 'loading...' })
        await CartService.addQty(this.state.selectedItem, qty)
            .then(response=>{
                this.setState({ selectedQty: qty + 1 })
               // alert(qty)
            })
            .catch(response=>{
               console.log("error")
            })
        
    }
    subQty= async e => {
        e.preventDefault();
        
        if(this.state.selectedQty > 0){
            let qty = this.state.selectedQty
            this.setState({ selectedQty: 'loading...' })
              await CartService.subQty(this.state.selectedItem, this.state.selectedQty)
              .then(response=>{
                    this.setState({ selectedQty: qty + 1 })
                    this.setState({ selectedQty: (qty > 0 )?qty - 1 : qty })
                })
              
        }
       if(this.state.selectedQty <= 0){
       // this.setState({btnTxt:'Add to cart'})
        this.setState({showQty:false})
        this.setState({selectedQty:1})
        this.getData()
        
      } 
    }
    selectItem  = async e => {

        this.ItemCode = e.target.value
        this.setState({ selectedItem: e.target.value })
        this.setState({ selectedDesc: e.target[e.target.selectedIndex].getAttribute('data-desc') })
        this.setState({ selectedRate: e.target[e.target.selectedIndex].getAttribute('data-rate') })
        this.checkItem(this.ItemCode)
    
    }
    
    async checkItem(item_code){
        const USR_TOKEN = localStorage.getItem("userToken")
        if(USR_TOKEN){
          let cart = AuthService.getserverCartitems();
          //console.log(cart)
            try{
                if(cart.length > 0){
                    this.setState({showQty:false})
                    for (let itm in cart) {
                           console.log(cart[itm]['item_code']===item_code)
                            if(cart[itm]['item_code']===item_code){
                                  this.setState({showQty:true})
                                  this.setState({selectedItem:cart[itm]['item_code']})
                                  this.setState({selectedQty:cart[itm]['qty']})
                                // this.setState({disabled:"disabled"})
                            }
                            
                      
                    } 
                }
            }
            catch(e){  }
          
  
        }
        else{
            let cart = AuthService.getCartitems()
            try{
                if(cart.length > 0){
                    this.setState({showQty:false})
                    for (let itm in cart) {
                           // console.log(cart[itm]['item_code'] + " - " + item_code)
                            if(cart[itm]['item_code']===item_code){
                                  this.setState({showQty:true})
                                  this.setState({selectedItem:cart[itm]['item_code']})
                                  this.setState({selectedQty:cart[itm]['qty']})
                                // this.setState({disabled:"disabled"})
                            }
                            
                      
                    } 
                }
            }
            catch(e){  }
        }
        
  
      }
    addToCart= async e => {
        e.preventDefault();       

       

            if(this.state.stockStatus){
                const delay = ms => new Promise(res => setTimeout(res, ms));
                try {
                
                            this.setState({showQty:"yes"})
                            let itemData={
                                item_code:this.state.selectedItem, 
                                item_name:this.state.selectedDesc?this.props.itm.item_name + ' - ' + this.state.selectedDesc : this.props.itm.item_name,
                                image:this.props.itm.image,
                                desc:'', 
                                qty: this.state.selectedQty, 
                                rate:this.state.selectedRate
                            }
                            await CartService.addToCart(itemData)
                            //await CartService.update_cart_local() 
                            //alert("vvv")
                            
                        await delay(1000);
                    
                }
                catch(err) {
                    console.log(err)
                    //  document.getElementById("options-selected").insertAdjacentHTML("beforeend","<div id='sdrop' ><strong>Drop</strong> : " + e.target.value + "</div>");                                 
                }
            }
        
    }
    
    render() {
        const rawHTML =this.props.itm.description.replace(/(<([^>]+)>)/gi,"");
         return <div className="row container pb-3 cart-product cart-items-border mb-3 cart-itm-shadow" >    
                    <div className="col-3 col-md-3 text-center">
                        <img src={this.props.itm.image ? process.env.REACT_APP_API_URL + this.props.itm.image : ''} style={{maxHeight: 150}}    className="cart-itm-img" alt=""/>
                    </div>
                    <div className="col-8 col-md-9 list-product variant-item-align">
                       <ul className="list-inline list-inline-dotted mb-3 mb-lg-2">
                            <li className="list-inline-item"><strong><p className="mb-0  cart-itm-color" data-abc="true" /* dangerouslySetInnerHTML={{ __html: rawHTML }} */ /> {this.props.itm.item_title}</strong></li>
                        </ul>
                        <p className="media-title font-weight-semibold mb-0 text-muted mobile-variant" data-abc="true">{this.props.itm.item_name} @ (<span className="rupay-font">₹</span> {this.props.itm.price})</p>
                            <div className="cart-btn  mob-add-to-cart-button pt-3">
                                   <a href="/#" className={ this.state.stockStatus ? "add-to-curt variant-add-minus-btn mobile-cart-btn-width" : "add-to-curt btn-secondary variant-add-minus-btn" } title="Add to cart" style={this.state.showQty ? { transform: 'scale(0)' } : { display: 'inline-block',transform: 'scale(1)' }} onClick={this.addToCart}>{this.state.btnTxt}</a>
                                </div>
                                <div className={this.state.showQty ? 'quantity-input counter-res-pos mob-add-minus-btn couter-align add-minus-index' : 'd-none '}>
                                    <button className="quantity-input__modifier quantity-input__modifier--left" onClick={this.subQty} addonType="prepend">
                                        &mdash;
                                    </button>
                                    <input className="quantity-input__screen " type="text" value={this.state.selectedQty} readonly />
                                    <button className="quantity-input__modifier quantity-input__modifier--right"  onClick={this.addQty} addonType="append">
                                       &#xff0b;
                                    </button>  
                                </div>
                    
                        </div>             
                </div>
                                 
        }
    }
    export default Variants;